import React from 'react';
import icon_search from 'assets/imgs/search.png';
import './style.scss';
import PropTypes from 'prop-types';
import InputText from 'components/InputText/InputText';

const InputSearch = ({ value, handleOnChange, onSearch, customClass, placeholder, autoFocus, onlyNumber, showIcon }) => {

  return (
    <div className={`search ${customClass || ''}`}>
      <InputText
        type="text"
        placeholder={placeholder || "Tìm kiếm"}
        extensionClass="search__input"
        value={value}
        handleOnChange={handleOnChange}
        onEnter={onSearch}
        autoFocus={autoFocus}
        onlyNumber={onlyNumber}
      />
      {(value === '' || showIcon) &&
        <img
          alt="icon-search"
          src={icon_search}
          className="search__icon"
          onClick={onSearch}
        />
      }
    </div>
  );
}

InputSearch.propTypes = {
  value: PropTypes.string,
  handleOnChange: PropTypes.func
};

InputSearch.defaultProps = {
  value: '',
  handleOnChange: () => {}
};

export default React.memo(InputSearch);
